const configSystem = {
  URL_API: process.env.REACT_APP_API_KEY,
};

export default configSystem;
